export default "__VITE_ASSET__bc13266c__"